import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { OpkraevningScopeEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/opkraevning-scope-enum';
import { ServiceafregningBasisEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceafregning-basis-enum';
import { StartAfregningRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/start-afregning-request';

@Component({
    selector: 'app-start-afregning-dialog',
    templateUrl: './start-afregning-dialog.component.html',
    styleUrls: ['./start-afregning-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StartAfregningDialogComponent implements OnInit {
  form: UntypedFormGroup;
  opkraevningsScope: OpkraevningScopeEnum;
  opkraevningsScopes: string[];

  afregningsType: ServiceafregningBasisEnum;
  afregningsTypes: string[];

  unsubscribe$ = new Subject<void>();

  constructor(private fb: UntypedFormBuilder, private dialog: MatDialogRef<StartAfregningDialogComponent>) {
    this.opkraevningsScopes = Object.keys(OpkraevningScopeEnum);
    this.afregningsTypes = Object.keys(ServiceafregningBasisEnum);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      afregningsType: new UntypedFormControl(null, Validators.required),
      opkraevningsScope: new UntypedFormControl(null, Validators.required),
    });
  }

  onAfregningsTypeChanged(id: string): void {
    this.afregningsType = ServiceafregningBasisEnum[id];
  }

  onOpkraevningsScopeChanged(id: string): void {
    this.opkraevningsScope = OpkraevningScopeEnum[id];
  }

  cancel() {
    this.dialog.close(null);
  }

  save() {
    const request: StartAfregningRequest = {
      serviceafregningBasis: this.form.controls.afregningsType.value,
      opkraevningScope: this.form.controls.opkraevningsScope.value,
    };

    this.dialog.close(request);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
